import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge align-middle align-text-top align-text-bottom", $options.pillStyle]),
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.clicked && $options.clicked(...args)))
  }, _toDisplayString($props.label), 3 /* TEXT, CLASS */))
}